export default "__VITE_ASSET__FY02AM5X__"